// Centralized image imports for data file usage
// This allows us to import images properly through webpack while still referencing them in data files

// Testimonial avatars
import allison from './testimonials/avatars/allison.webp';
import avery from './testimonials/avatars/avery.webp';
import ben from './testimonials/avatars/ben.webp';
import jacob from './testimonials/avatars/jacob.webp';
import mammy from './testimonials/avatars/mammy.webp';
import sylvie from './testimonials/avatars/sylvie.webp';
import tay from './testimonials/avatars/tay.webp';
import tom from './testimonials/avatars/tom.webp';

// Team member photos
import ava from './team/ava.webp';
import david from './team/david.webp';
import gabe from './team/gabe.webp';
import jake from './team/jake.webp';
import liam from './team/liam.webp';
import sarah from './team/sarah.webp';

// Export organized image maps
export const testimonialsAvatars = {
  allison,
  avery,
  ben,
  jacob,
  mammy,
  sylvie,
  tay,
  tom,
} as const;

export const teamImages = {
  ava,
  david,
  gabe,
  jake,
  liam,
  sarah,
} as const;

// Export everything for convenience
export const images = {
  testimonials: testimonialsAvatars,
  team: teamImages,
} as const;